const initialState = () => ({
  isLoading: false
})

const state = initialState()

const actions = {
  show (context) {
    context.commit('LOADER_SHOW')
  },
  hide (context) {
    context.commit('LOADER_HIDE')
  }
}

const mutations = {
  LOADER_SHOW (state) {
    state.isLoading = true
  },
  LOADER_HIDE (state) {
    state.isLoading = false
  }
}

const getters = {
  isLoading: state => {
    return state.isLoading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
